import { useLineItemEditorOutletConnector } from 'InvoiceEditor/components/LineItems/drawer/LineItemEditor/useLineItemEditorOutletConnector'
import { LineItemEditorRoot } from 'InvoiceEditor/components/LineItems/drawer/LineItemEditor/components/LineItemEditorRoot'

export const LineItemEditorRouteComponent = () => {
  const invoiceEditorLineItemContext = useLineItemEditorOutletConnector()

  return <LineItemEditorRoot {...invoiceEditorLineItemContext} />
}
